<template>
  <div>
    <div v-if="videos.length>0"> 
      <b-table v-if="loaded"
        small
        ref="table"
        id="my-table"
        responsive
        :items="videos"
        :current-page="currentPage"
        :fields="tableFields"
        :selected.sync="selectedVideos"
        @selected-rows="selectedRows">
        <template v-slot:cell(thumbnail)="data">
          <img :src="data.value" alt="Image" width="200" height="100">
        </template >
        <template v-slot:cell(video_status)="status">
          <span class="text-yellow" v-if="status.value === 'Baseline-success' || status.value === 'Baseline-started' || status.value === 'new' ||  status.value === 'Download-started' || status.value === 'Download-failed'">AI Training in Progress</span>
          <span class="text-blue" v-if="status.value === 'Testing-started'">AI Validation in Progress</span>
          <span class="text-red" v-if="status.value === 'Baseline-failed' || status.value === 'Testing-failed'">Video not Compatible</span>
          <span class="text-green" v-if="status.value === 'save-to-s3' || status.value === 'Testing-success'">AI Activated</span>
        </template>
        <template v-slot:cell(id)="id">
          <span>
            <b-button class="btn btn-light" @click="editVideo(id.value)" v-if="hasAccessPermission('edit_videos')">
              <b-icon icon="pen"></b-icon>
            </b-button> &nbsp;
            <b-button class="btn btn-light" @click="deleteVideo(id.value)" v-if="hasAccessPermission('delete_videos')">
              <b-icon icon="trash"></b-icon>
            </b-button>
          </span>
        </template>
        <template v-slot:cell(featured_videos)="featured_videos">
          <b-button v-if="featured_videos.value.length == 1" class="btn btn-light" @click="unPinVideo(featured_videos.item.id)">
            <b-icon icon="bookmark-fill"></b-icon>
          </b-button>
          <b-button v-else class="btn btn-light" @click="pinVideo(featured_videos.item.id)"> 
            <b-icon icon="bookmark"></b-icon> 
          </b-button> 
        </template>
      </b-table>
      <b-pagination
        align="center"
        v-model="currentPage"
        :total-rows="rows"
        :per-page="perPage"
        aria-controls="my-table">
      </b-pagination>
      <b-modal id="video-edit-modal" modal-class="videoEditModal" title="Edit Video" @hide="collapseModal()" hide-footer>
        <video-edit :videoId="videoId"></video-edit>
      </b-modal>
    </div>
    <div v-else class="emptyVideos">
      <div>
        <h1>No videos added</h1>
        <p>Start integrating your content with AI</p>
        <b-button @click="openVideoUpload()" class="btn btn-secondary btn-lg upload-btn">+ Upload</b-button>
      </div>
    </div>
  </div>
</template>
<script>
import api from '../../api.js';
import VideoEdit from './VideoEdit.vue';
import {permissionsMixin} from "@/utils/accessPermission.js"
export default {
  name: 'video-list',
  components: {
    'video-edit': VideoEdit
  },
  computed: {
    rows() {
      return this.trainerVideos.data.data.totalRecords ? this.trainerVideos.data.data.totalRecords: 0;
    }
  },
  mixins: [permissionsMixin],
  data: function() {
    return {
        perPage: 10,
        currentPage: 1,
        videos: {},
        trainerVideos: null,
        pinnedVideos: null,
        loaded: false,
        isSelected: false,
        showVideoEdit: false,
        showTable: true,
        videoId: null,
        showEmpty:false,
        selectedVideos: [],
        tableFields: [
          { key: 'thumbnail', label: 'Video Thumbnail'},
          { key: 'title', label: 'Title', sortable: true, thStyle: { width: "30%" }},
          { key: 'video_status', label: 'Status', sortable: true},
          { key: 'duration', label: 'Duration', sortable: true},
          { key: 'start', label:'Start Time', sortable: true},
          { key: 'end', label: 'End Time', sortable: true},
          { key: 'created_at', label: 'Upload Date', sortable: true},
          { key: 'id', label: 'Action'},
          { key: 'featured_videos', label:'Featured'}
        ]
      }
    },
    methods: {
      async getTrainerVideos() {
        this.userId = this.$store.state.userInfo.userId;
        if (this.userId) {
        this.trainerVideos = await api.getTrainerVideos(this.userId, this.currentPage, this.perPage);
        this.pinnedVideos = (await api.getPinnedVideos()).data;
        this.videos = this.trainerVideos.data.data.rows;
        this.loaded = true;
        }
        else {
          this.router.push('/management');
        }
      },
      
      // Pin Un-Pin Videos (Featured Videos)
      async pinVideo(id) {
        let requestData =  {
          video_id: id
        }
        let pinned = await api.pinVideo(requestData);
        if(pinned.code === 202) {
            this.$bvToast.toast(`${pinned.message}`,
              { variant: "danger" });
         } else if(pinned.code === 200) {
            this.$bvToast.toast(`${pinned.message}`,
              { variant: "success" });
          }
        else {
          this.$bvToast.toast(`Error`,
            { variant: "success" });
        }
      },
      async unPinVideo(id) {
        const unPinned = await api.unPinVideo(id);
        if(unPinned.status == 200) {
          this.getTrainerVideos();
          this.$refs.table.refresh();
        }
      },

      async deleteVideo(id) {
        if (window.confirm('Are you sure you want to delete this Video?')) {
          let deleteResponse = await api.deleteVideo(id);
          if (deleteResponse.status == 200) {
              this.getTrainerVideos();
          }
          else {
          this.$bvToast.toast(`Video Delete Unsuccessfull`,
            { variant: "success" });
          }
        }
      },
      async editVideo(videoId) {
        this.videoId = videoId;
        this.$bvModal.show('video-edit-modal');
      },
      async selectedRows() {
        this.isSelected = true;
        console.log(this.selectedVideos);
      },
      async openVideoUpload() {
        this.$router.push('/management/conditions');
      },
      collapseModal() {
        this.getTrainerVideos();
      }
    },
    watch: {
      currentPage: {
        handler() {
          this.getTrainerVideos();
          this.$refs.table.refresh();
        }
      },
      selectedVideos: {
        handler() {
          console.log(this.selectedVideos);
        }
      }
    },
    mounted() {
      this.getTrainerVideos();
    }
  }
</script>
<style scoped>

.videoEditModal {
  position: relative;
  display: flex;
  flex-direction: column;
  width: 50%;
  pointer-events: auto;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 0.3rem;
  outline: 0;
  margin: auto;
}

.emptyVideos{
  margin-top:25%;
  text-align: center;
}
.upload-btn{
  border: 0px solid black;
  border-radius: 20px;
}

.text-red {
  color: red;
}

.text-green {
  color: green;
}

.text-yellow{
  color: yellowgreen;
}

.text-blue {
  color: blue;
}
</style>
